import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingPageContainer from "../general/NtMarketingPageContainer";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtSectionButton from "../general/NtSectionButton";
import { useNavigation } from "@react-navigation/native";
import routes from "../../../navigation/routes";

function NtHomeConnectYourWaySection(props) {
  const nav = useNavigation();
  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/0f080021e59347ba9ef4a22112d31cc5f2cbaf0a.jpg")}
      opacity={0.1}
    >
      <View
        style={{
          flex: 1,
          flexDirection: "row",
          paddingTop: 20,
          paddingBottom: 20,
        }}
      >
        <View style={{ flex: 1, marginRight: 40 }}>
          <NtSectionTitle style={{ textAlign: "left", marginTop: 30 }}>
            CONNECT YOUR WAY
          </NtSectionTitle>
          <NtSectionDescription style={{ marginTop: 15 }}>
            We Offer Multiple Ways to Stay Connected With your World.
          </NtSectionDescription>
        </View>
        <View
          style={{
            flex: 1,
            justifyContent: "flex-end",
            alignItems: "flex-start",
          }}
        >
          <NtSectionTitle
            style={{ textAlign: "left", fontWeight: "900", marginTop: 10 }}
          >
            CLOUD-BASED PBX
          </NtSectionTitle>
          <NtSectionTitle
            style={{ textAlign: "left", fontWeight: "200", marginTop: 10 }}
          >
            BORDERLESS BUSINESS
          </NtSectionTitle>
          <NtSectionTitle
            style={{ textAlign: "left", fontWeight: "900", marginTop: 10 }}
          >
            PHONE SERVICE
          </NtSectionTitle>
          <NtSectionDescription style={{ marginTop: 10 }}>
            Big Business Features for Small Business.
          </NtSectionDescription>

          <NtSectionButton
            containerStyle={{ marginTop: 30, paddingTop: 6, paddingBottom: 6 }}
            title="LEARN MORE"
            color="white"
            onPress={() => {
              nav.navigate(routes.business);
            }}
          />
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 500,
  },
});

export default NtHomeConnectYourWaySection;
